import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import decodePolylineForWebWorker from "../../helper/boundaries/decodePolylineForWebWorker";

const initialState = {
  isLoadingGetRegionsBoundaries: false,
  regionsBoundariesList: [],
  selectedRegion: null,
  boundaryDepth: 1,

  isLoadingGetCitiesBoundaries: false,
  citiesBoundariesList: [],
  selectedCity: null,

  isLoadingGetTownsBoundaries: false,
  townsBoundariesList: [],
  selectedTown: null,

  regionsUserCounts: [],
  citiesUserCounts: [],

  userBoundariesList: [],

  isListView: false,


  //! searchText
  searchText: "",
  searchDepth: null,

  isLoadingGetLocationSearchResult: false,
  locationSearchResultList: [],

  isLoadingGetSearchResultBoundaries: false


};

// Ortak GET isteği ve polyline decode işlemi
const fetchBoundaries = async (url, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(url);
    
    return await decodePolylineForWebWorker(data.data.$values);
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
};

export const getRegionsBoundaries = createAsyncThunk(
  "boundaries/getRegionsBoundaries",
  async (_, thunkApi) => {
    return await fetchBoundaries(`/bndrs/Garb`, thunkApi);
  }
);

export const getCitiesBoundaries = createAsyncThunk(
  "boundaries/getCitiesBoundaries",
  async ({ regionId }, thunkApi) => {
    return await fetchBoundaries(`/bndrs/Gcbbri?id=${regionId}`, thunkApi);
  }
);

export const getTownsBoundaries = createAsyncThunk(
  "boundaries/getTownsBoundaries",
  async ({ cityId }, thunkApi) => {
    return await fetchBoundaries(`/bndrs/Gtbbci?id=${cityId}`, thunkApi);
  }
);


export const getLocationSearchResult = createAsyncThunk("boundaries/getLocationSearchResult", async(searchText, thunkApi)=> {
  try {
      const {data} = await axiosInstance.get(`/bndrs/LocationSearch?locationName=${searchText}`)
      
      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})


export const getSearchResultBoundaries = createAsyncThunk("boundaries/getSearchResultBoundaries", async({regionId, cityId, townId, type, quarterId}, thunkApi)=> {
//! region, city, town
  try {
      const {data} = await axiosInstance.get(`/bndrs/getSearchResultBoundaries?regionId=${regionId}&&cityId=${cityId}${townId ? `&&townId=${townId}` : ""}&&type=${type}`)
      
      const searchDepth = (regionId && cityId && townId) ? 3 : (regionId && cityId) ? 2 : 1

      const citiesBoundariesList = await decodePolylineForWebWorker(data.data.cityBoundaries.map(item => {
        return {
          ...item,
          coords: {
            $values: item.coords
          }
        }
      }));


       const townsBoundariesList = await decodePolylineForWebWorker(data.data.townBoundaries.map(item => {
          return {
            ...item,
            coords: {
              $values: item.coords
            }
          }
        }));
      
      // const insideUsersIds = userBoundariesList.filter(userItem => item.cityId === userItem.insideBoundaryCityId).map(userItem => userItem.id)
      // console.log(insideUsersIds);
      
      // dispatch(setFilteredUsersLocations({data: allUsersLocationList.filter(userItem => insideUsersIds.includes(userItem.id)), type: "filter"}))
      
      return {townBoundaries: townsBoundariesList, cityBoundaries: citiesBoundariesList, searchDepth: searchDepth, selectedRegionId: regionId, selectedCityId: cityId, selectedTownId: townId}
  } catch (error) {
    console.log(error);
    
      return thunkApi.rejectWithValue(error)
  }
})



const boundariesSlice = createSlice({
  name: "boundaries",
  initialState,
  reducers: {
    setBoundaryDepth: (state, action) => {
      state.boundaryDepth = action.payload;
    },
    setSelectedRegion: (state, action) => {
      state.selectedRegion = action.payload;
    },
    setSelectedCity: (state, action) => {
      state.selectedCity = action.payload;
    },
    setSelectedTown: (state, action) => {
      state.selectedTown = action.payload;
    },

    setRegionsUserCounts: (state,action) => {
      
      state.regionsUserCounts = action.payload
    },

    setCitiesUserCounts: (state,action) => {
      state.citiesUserCounts = action.payload
    },
    

    setUserBoundariesList: (state,action) => {
      const {data, type} = action.payload
      
      if(type === "region"){
        state.userBoundariesList = data
      }

      else if (type === "city"){
        state.userBoundariesList = state.userBoundariesList.map((item, i) => {
          return {
            insideBoundaryRegionId: item.insideBoundaryRegionId, 
            id: item.id,
            insideBoundaryCityId: data[i].insideBoundaryCityId
          }
        })
      }
    },

    setSearchText: (state,action) => {
      state.searchText = action.payload 
    },

    topSelectBoundaryDepth: (state,action) => {
      const {type} = action.payload

      if(type === 1){

        state.boundaryDepth = 1;
        state.selectedRegion = null;

        state.isLoadingGetCitiesBoundaries = false;
        state.citiesBoundariesList = [];
        state.selectedCity = null;

        state.isLoadingGetTownsBoundaries = false;
        state.townsBoundariesList = [];
        state.selectedTown = null;
      }
      else if(type === 2){

        state.boundaryDepth = 2;
        state.selectedCity = null;

        state.isLoadingGetTownsBoundaries = false;
        state.townsBoundariesList = [];
        state.selectedTown = null;
      }
    },

    setIsListView: (state, action) => {
      if(action.payload === true || action.payload === false){
        state.isListView = action.payload
      }
      else{
        state.isListView = !state.isListView
      }
    },



    resetBoundariesState: (state) => {
      state.isLoadingGetRegionsBoundaries= false
      state.boundaryDepth= 1
      state.selectedRegion = null
      
      state.isLoadingGetCitiesBoundaries= false
      state.citiesBoundariesList= []
      state.selectedCity= null
    
      state.isLoadingGetTownsBoundaries= false
      state.townsBoundariesList= []
      state.selectedTown= null
    
      state.regionsUserCounts= []
      state.citiesUserCounts= []
  
      state.userBoundariesList= []
  
      state.isListView= false
    
    
      //! searchText
      state.searchText = ""
      state.searchDepth= null
    
      state.isLoadingGetLocationSearchResult= false
      state.locationSearchResultList= []
    
      state.isLoadingGetSearchResultBoundaries= false
    }
    
  },
  extraReducers: (builder) => {
    builder
      //! getRegionsBoundaries
      .addCase(getRegionsBoundaries.pending, (state) => {
        state.isLoadingGetRegionsBoundaries = true;
        state.townsBoundariesList = [];
        state.citiesBoundariesList = [];
      })
      .addCase(getRegionsBoundaries.fulfilled, (state, action) => {
        state.isLoadingGetRegionsBoundaries = false;
        state.regionsBoundariesList = action.payload;
      })
      .addCase(getRegionsBoundaries.rejected, (state) => {
        state.isLoadingGetRegionsBoundaries = false;
      })

      //! getCitiesBoundaries
      .addCase(getCitiesBoundaries.pending, (state) => {
        state.isLoadingGetCitiesBoundaries = true;
        state.townsBoundariesList = [];
      })
      .addCase(getCitiesBoundaries.fulfilled, (state, action) => {
        state.isLoadingGetCitiesBoundaries = false;
        state.boundaryDepth = 2;
        state.citiesBoundariesList = action.payload;
      })
      .addCase(getCitiesBoundaries.rejected, (state) => {
        state.isLoadingGetCitiesBoundaries = false;
      })

      //! getTownsBoundaries
      .addCase(getTownsBoundaries.pending, (state) => {
        state.isLoadingGetTownsBoundaries = true;
      })
      .addCase(getTownsBoundaries.fulfilled, (state, action) => {
        state.isLoadingGetTownsBoundaries = false;
        state.boundaryDepth = 3;
        state.townsBoundariesList = action.payload;
      })
      .addCase(getTownsBoundaries.rejected, (state) => {
        state.isLoadingGetTownsBoundaries = false;
      })

      //! getLocationSearchResult
      .addCase(getLocationSearchResult.pending, (state) => {
        state.isLoadingGetLocationSearchResult = true;
      })
      .addCase(getLocationSearchResult.fulfilled, (state, action) => {
        state.isLoadingGetLocationSearchResult = false;
        state.locationSearchResultList = action.payload.data.$values
      })
      .addCase(getLocationSearchResult.rejected, (state) => {
        state.isLoadingGetLocationSearchResult = false;
      })


      //! getSearchResultBoundaries
      .addCase(getSearchResultBoundaries.pending, (state) => {
        state.isLoadingGetSearchResultBoundaries = true;
      })
      .addCase(getSearchResultBoundaries.fulfilled, (state, action) => {
        state.isLoadingGetSearchResultBoundaries = false;
        state.citiesBoundariesList = action?.payload?.cityBoundaries

        state.boundaryDepth = action?.payload?.searchDepth+1
        state.searchDepth = action?.payload?.searchDepth
        
        const newSelectedCity =  action?.payload?.cityBoundaries?.find(item => item?.cityId === action?.payload?.selectedCityId) 
        state.selectedCity = {cityId: newSelectedCity?.cityId, id: newSelectedCity?.id, cityName: newSelectedCity?.cityName, centerCoords: newSelectedCity?.centerCoords}

        const newSelectedRegion = state?.regionsBoundariesList?.find(item => item?.regionId === action?.payload?.selectedRegionId) 
        state.selectedRegion = {regionId: newSelectedRegion?.regionId, id: newSelectedRegion?.id, regionName: newSelectedRegion?.regionName, centerCoords: newSelectedRegion?.centerCoords}

        state.townsBoundariesList = action?.payload?.townBoundaries

        if(action?.payload?.searchDepth === 2){
          state.selectedTown = null
        }
        if(action?.payload?.searchDepth > 2){

          const newSelectedTown =  action?.payload?.townBoundaries?.find(item => item?.townId === action.payload.selectedTownId) 
          state.selectedTown = {townId: newSelectedTown?.townId, id: newSelectedTown?.id, townName: newSelectedTown?.townName, centerCoords: newSelectedTown?.centerCoords}
        }

      })
      .addCase(getSearchResultBoundaries.rejected, (state) => {
        state.isLoadingGetSearchResultBoundaries = false;
      })
  },
});

export const {
  setBoundaryDepth,
  setSelectedRegion,
  setSelectedCity,
  setSelectedTown,
  topSelectBoundaryDepth,
  setRegionsUserCounts,
  setCitiesUserCounts,

  setUserBoundariesList,

  setSearchText,

  setIsListView,

  resetBoundariesState
} = boundariesSlice.actions;
export default boundariesSlice.reducer;
